<template>
  <div id="app" class="mt-3">
    <router-view/>
  </div>
</template>

<script>
  export default {
    name: 'app',
    components: {},
    computed: {
      isDesigner () {
        return false
        // return mode === 'designer'
      }
    }
  }
</script>

<style>
  @font-face {
    font-family: "Iransans";
    font-style: normal;
    font-weight: normal;
    src: url('/fonts/iransans.ttf');
  }

  body, .btn {
    font-family: Iransans, 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    padding: 4px;
    background-color: #0f2335;
    color: white;
  }

  h3 {
    margin-bottom: 0;
  }

  .header, .breadcrumb {
    background-color: #225079;
  }

  .header {
    padding: 2px;
    text-align: center;
  }

  a, a:visited {
    color: #9acfea;
  }

  a:hover {
    color: #00b3ee;
  }

  input, textarea, select {
    color: black;
  }

  .breadcrumb {
    padding: 0 0 10px 10px;
    text-align: left;
  }
  .breadcrumb {
    color: #ffd6e2;
  }
  .breadcrumb a {
    color: #fb9cff;
  }
  .breadcrumb span {
    width: 100%;
  }

  .btn {
    border: none; /* Remove borders */
    color: white; /* Add a text color */
    padding: 14px 28px; /* Add some padding */
    cursor: pointer; /* Add a pointer cursor on mouse-over */
    border-radius: 5px;
  }
  .btn:disabled {
    background: #aaa;
    color: gray;
    cursor: not-allowed
  }

  .success {background-color: #4CAF50;} /* Green */
  .success:hover {background-color: #46a049;}

  .info {background-color: #2196F3;} /* Blue */
  .info:hover {background: #0b7dda;}

  .warning {background-color: #ff9800;} /* Orange */
  .warning:hover {background: #e68a00;}

  .danger {background-color: #f44336;} /* Red */
  .danger:hover {background: #da190b;}

  .default {background-color: #e7e7e7; color: black;} /* Gray */
  .default:hover {background: #ddd;}


</style>



// WEBPACK FOOTER //
// src/App.vue